import { Mail, Instagram, ArrowUpRight, ArrowRight, Phone } from "lucide-react";
import { Wordmark } from "./Wordmark";
import { CONTACT, NAV_LINKS } from "../lib/data";

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="site-footer" className="relative border-t border-[#D4AF37]/20 bg-[#050505] pt-16 md:pt-20 pb-8 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 md:gap-12 pb-14 md:pb-16">
          <div className="lg:col-span-5">
            <Wordmark good="text-2xl md:text-3xl" esp="text-[0.65rem]" />
            <p className="mt-6 font-display uppercase tracking-[0.18em] text-[#D4AF37] text-sm md:text-base">
              One Good Shot Changes Everything.
            </p>
            <button
              data-testid="footer-quote"
              onClick={() => go("#inquiry")}
              className="mt-7 inline-flex items-center gap-2 bg-[#D4AF37] text-black uppercase tracking-[0.14em] text-[11px] font-bold px-6 py-4 hover:bg-[#F3E5AB] transition-colors duration-300"
            >
              Request A Quote <ArrowRight className="w-4 h-4" />
            </button>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-6">Explore</p>
            <div className="flex flex-col gap-3">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.href}
                  data-testid={`footer-nav-${l.href.replace("#", "")}`}
                  onClick={() => go(l.href)}
                  className="text-left text-sm uppercase tracking-[0.16em] text-white/70 hover:text-[#D4AF37] transition-colors"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4">
            <p className="text-[11px] uppercase tracking-[0.3em] text-white/40 mb-6">Contact</p>
            <div className="space-y-4">
              <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-white/80 hover:text-[#D4AF37] transition-colors break-all">
                <Mail className="w-4 h-4 text-[#D4AF37] shrink-0" /> {CONTACT.email}
              </a>
              <a data-testid="footer-instagram" href={CONTACT.instagramHref} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/80 hover:text-[#D4AF37] transition-colors group">
                <Instagram className="w-4 h-4 text-[#D4AF37] shrink-0" /> @{CONTACT.instagram}
                <ArrowUpRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
              </a>
              <a data-testid="footer-phone" href={CONTACT.phoneHref} className="flex items-center gap-3 text-white/80 hover:text-[#D4AF37] transition-colors">
                <Phone className="w-4 h-4 text-[#D4AF37] shrink-0" /> {CONTACT.phone}
              </a>
            </div>
          </div>
        </div>

        <div className="font-display font-black uppercase leading-none text-white/[0.06] tracking-tighter text-[19vw] lg:text-[15vw] select-none -mb-3 md:-mb-8">
          Good Shot
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/35 text-xs">© {new Date().getFullYear()} Good Shot Espresso. All rights reserved.</p>
          <p className="text-white/35 text-xs uppercase tracking-[0.2em]">Nationwide · United States</p>
        </div>
      </div>
    </footer>
  );
};
